module.exports = __webpack_public_path__ + "img/borderRing2_UPWhite.74be2726.svg";